import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class BranchQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_fi_mst_branch table
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  comp_guid?: Optional<string> = Optional.empty();
  tax_registration_id?: Optional<string> = Optional.empty();
  ccy_code?: Optional<string> = Optional.empty();

  //For bl_fi_mst_branch_ext table
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
}

export class BranchCriteriaModelQuery {
  query = '';

  constructor(public branchCriteriaModel: BranchQueryCriteriaClass) {

    if (!branchCriteriaModel) {
      return;
    }

    this.query += branchCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += branchCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += branchCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += branchCriteriaModel.tax_registration_id.filter(x => x !== '').map(x => '&tax_registration_id=' + x).orElse('');
    this.query += branchCriteriaModel.ccy_code.filter(x => x !== '').map(x => '&ccy_code=' + x).orElse('');

    this.query += branchCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += branchCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += branchCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += branchCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += branchCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += branchCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += branchCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');

    this.query += '&status=' + branchCriteriaModel.status;
    // this.query += '&orderBy=' + branchCriteriaModel.orderBy;
    this.query += '&order=' + branchCriteriaModel.order;
    this.query += '&offset=' + branchCriteriaModel.offset + '&limit=' + branchCriteriaModel.limit;
  }


}
